import { OverlayRef } from '@angular/cdk/overlay';
import { Subject, Observable } from 'rxjs';
import { take } from 'rxjs/operators';

/**
 * Reference to a modal opened via ModalService.
 * Drop-in replacement for MatDialogRef.
 */
export class ModalRef<T = any, R = any> {

  componentInstance: T | null = null;

  private readonly _afterClosed = new Subject<R | undefined>();
  private readonly _backdropClick = new Subject<MouseEvent>();
  private _result: R | undefined;

  constructor(
    private _overlayRef: OverlayRef,
    public disableClose: boolean = false
  ) {}

  /** Close the modal with an optional result value. */
  close(result?: R): void {
    this._result = result;
    this._overlayRef.dispose();
    this._afterClosed.next(this._result);
    this._afterClosed.complete();
    this._backdropClick.complete();
  }

  /** Observable that emits when the modal is closed. */
  afterClosed(): Observable<R | undefined> {
    return this._afterClosed.asObservable();
  }

  /** Observable that emits when the backdrop is clicked. */
  backdropClick(): Observable<MouseEvent> {
    return this._backdropClick.asObservable();
  }

  /** @internal Emit a backdrop click event. */
  _emitBackdropClick(event: MouseEvent): void {
    this._backdropClick.next(event);
  }
}
